import { combineReducers } from 'redux'

import orderBuilder from './orderBuilder'

export default combineReducers({
  orderBuilder,
})
